module.exports = require("alerts");